export const environment = {
  backendUrl: 'https://staging.ai-crm.frednh.fr',
  apiUrl: 'https://staging.ai-crm.frednh.fr/api',
  production: false,
};
